// FILE: src/components/content.js
import {
  collection,
  addDoc,
  getDocs,
  deleteDoc,
  doc,
  serverTimestamp,
  getDoc,
} from "firebase/firestore";
import { ref as storageRef, deleteObject } from "firebase/storage";
import { db, storage } from "../firebase";

const contentCol = collection(db, "content");

/**
 * uploadContentMeta(meta)
 * meta: { title, fileUrl, storagePath, size?, mimeType?, description?, type? }
 */
export async function uploadContentMeta(meta) {
  const payload = {
    ...meta,
    createdAt: serverTimestamp(),
  };
  const ref = await addDoc(contentCol, payload);
  return { id: ref.id };
}

export async function listContent() {
  const snap = await getDocs(contentCol);
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}

export async function deleteContent(id) {
  // keep for backward compatibility: deletes only Firestore doc
  return await deleteDoc(doc(db, "content", id));
}

/**
 * deleteContentWithStorage(id)
 * Deletes the Firestore doc AND the referenced storage file (if storagePath present)
 * Returns: { deletedDoc: true, deletedStorage: true|false }
 */
export async function deleteContentWithStorage(id) {
  try {
    // 1) read doc to find storagePath
    const docRef = doc(db, "content", id);
    const snap = await getDoc(docRef);
    if (!snap.exists()) {
      return { deletedDoc: false, deletedStorage: false, reason: "doc-not-found" };
    }
    const data = snap.data();
    const storagePath = data?.storagePath;

    // 2) delete Firestore doc
    await deleteDoc(docRef);

    // 3) delete storage object if path exists
    if (storagePath) {
      try {
        const sRef = storageRef(storage, storagePath);
        await deleteObject(sRef);
        return { deletedDoc: true, deletedStorage: true };
      } catch (err) {
        console.warn("deleteContentWithStorage: storage delete failed", err);
        return { deletedDoc: true, deletedStorage: false, storageError: err.message || String(err) };
      }
    }

    return { deletedDoc: true, deletedStorage: false, reason: "no-storagePath" };
  } catch (err) {
    console.error("deleteContentWithStorage error:", err);
    throw err;
  }
}

/* Export a named object to satisfy ESLint */
const ContentService = {
  uploadContentMeta,
  listContent,
  deleteContent,
  deleteContentWithStorage,
};

export default ContentService;
